import axios from 'axios'
import { url } from '@/api/url'
import { HeadersWithCredentials } from '@/api/header'

const prefix = `${url}/contract`

export const getContractInfo = async (eventIdentifier) => {
    return await axios.get(`${prefix}/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getContractSigningInfo = async (eventIdentifier, params = {}) => {
    return await axios.get(`${prefix}/signing/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
        params,
    })
}

export const getContractSignaturesInfo = async (eventIdentifier) => {
    return await axios.get(`${prefix}/signatures/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}
export const getVolunteersContractInfo = async (eventIdentifier) => {
    return await axios.get(`${prefix}/volunteers/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getVolunteersContractSigningInfo = async (eventIdentifier) => {
    return await axios.get(`${prefix}/volunteers/signing/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getVolunteersContractSignaturesInfo = async (eventIdentifier) => {
    return await axios.get(`${prefix}/volunteers/signatures/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const updateContract = async (competitionId, contractId, title, content, deadline) => {
    return await axios.put(
        `${prefix}/${competitionId}/${contractId}`,
        { title, content, deadline },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const updateContractActivation = async (competitionId, contractId, isActive) => {
    return await axios.put(
        `${prefix}/${competitionId}/activation/${contractId}`,
        { isActive },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const signContract = async (contractId, orderId, position, newSignature) => {
    return await axios.put(
        `${prefix}/sign/${contractId}/${orderId}`,
        { position, newSignature },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const requestOneSignature = async (competitionId, contractId, orderId, position) => {
    return await axios.put(
        `${prefix}/request/${competitionId}/${contractId}/${orderId}/${position}`,
        {},
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const requestAllSignatures = async (competitionId, contractId) => {
    return await axios.put(
        `${prefix}/request-all/${competitionId}/${contractId}`,
        {},
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const downloadAllSignatures = async (competitionId, contractId) => {
    return await axios.get(`${prefix}/download-all/${competitionId}/${contractId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const accountContracts = async (userId) => {
    return await axios.get(`${prefix}/account-contracts/${userId}`, {
        headers: HeadersWithCredentials(),
    })
}
